/**
 * Leaf constants `ExcelSharedService` needs, gathered here in L2-S4 when that service moved into
 * this library. Each old host path re-exports from here:
 *   - `europeanLocales`            <- `@shared/services/excel-enum`
 *   - `lookupDynamicExtensions`    <- `@shared/models/lookup.constants`
 *   - `CONTACT_CELL_*`             <- `@shared/components/table/table.constants` (shared with the
 *                                     ag-grid contact-cell renderer, hence the re-export)
 */
// European locales typically use semicolon as CSV delimiter

export const europeanLocales = new Set([
  'nl',
  'de',
  'fr',
  'es',
  'it',
  'pt',
  'da',
  'sv',
  'no',
  'fi',
  'pl',
  'cs',
  'sk',
  'hu',
  'ro',
  'bg',
  'hr',
  'sl',
  'et',
  'lv',
  'lt',
]);

export const lookupDynamicExtensions = {
  property: {
    'property_measurement/property_measurement_size_uom': 'property_measurement/property_element_type_desc',
  },
};

// Bullet characters shared by contact cell renderers (grid + Excel export)
export const CONTACT_CELL_COMPANY_BULLET = '\u2022'; // •
export const CONTACT_CELL_CONTACT_BULLET = '\u25E6'; // ◦
export const CONTACT_CELL_CHILD_INDENT = '  ';
